import { configReducer } from '../../store/config/config.reducer';
import { postPageReducer } from '../../store/template/postPage/postPage.reducer';
import {
  getArticleId,
  getBlockNames,
  getChannels,
  getCommercialTags,
  getContentTypesToQuantity,
  getCover,
  getDfpCategory,
  getNumberOfWordsTyped,
  getOwnerName,
  getTags,
  getTitle,
  getOwnerUsername,
  getSlideshowData,
  getCreatedAtISO,
  getUpdatedAtISO,
  getFiniteScrollDataExists,
  getBreadCrumbs,
  getAuthorsUsernames,
  getTopic,
  getIntro, getSeoTitle,
} from '../../store/template/postPage/postPagePrague/postPagePrague.selectors';
import { TemplateRegistration } from '../templateRegistration';
import { AppState } from '../../store/initialStateRegistration';
import {
  GET_PAGE_DATA,
  GET_PALETTE_DATA, INJECT_ADS,
  INJECT_ARTICLE_BLOCK_BY_INDEX_ARRAY,
  INJECT_BUTTON_TO_FOOTER_LINKS_SECTION,
  INJECT_BUTTON_TO_MENU,
  INJECT_VIDEO_LOGO,
} from '../../client/clientAPI/events';
import { formatDate, getCountryCode, getCoverType } from '../templates.utils';
import { announcementReducer } from '../../store/announcement/announcement.reducer';
import { PostPagePragueComponent } from './PostPagePragueComponent';
import { ArticlePageViewParameters, ConfigPageViewParameters } from '../utils/articleComponent.utils';
import { getAnalyticsCoreParamsForAllPages } from '../utils/getAnalyticsCoreParams';

export const rootReducer = {
  config: configReducer,
  template: postPageReducer,
  siteAnnouncement: announcementReducer,
};

const getCoreParams = (state: AppState): ArticlePageViewParameters & ConfigPageViewParameters => ({
  ...getAnalyticsCoreParamsForAllPages(state),
  articleId: getArticleId(state),
  articleTemplate: getBlockNames(state),
  channels: getChannels(state),
  articleAuthor: getOwnerName(state),
  ownerUsername: getOwnerUsername(state),
  articleTitle: getTitle(state),
  articleIntro: !!getIntro(state) && getIntro(state)?.length !== 0,
  articlePublicationTime: formatDate(getCreatedAtISO(state)),
  authorsUsernames: getAuthorsUsernames(state),
  contentTags: getTags(state),
  mainMedia: getCoverType(getCover(state)),
  countryCode: getCountryCode(),
  commercialTags: getCommercialTags(state),
  dfpCategory: getDfpCategory(state),
  articleContentCount: getContentTypesToQuantity(state),
  articleWordCount: getNumberOfWordsTyped(state),
  createdAt: getCreatedAtISO(state),
  updatedAt: getUpdatedAtISO(state),
  isSlideshow: !!getSlideshowData(state).totalSlides,
  mainCategoryEmbed: !!(getBreadCrumbs(state)?.categoryLink && getBreadCrumbs(state)?.isActive),
  finiteScrollDataExists: getFiniteScrollDataExists(state),
  topic: getTopic(state),
  seoTitle: getSeoTitle(state),
});

export const PostPagePrague = new TemplateRegistration()
  .setComponent(PostPagePragueComponent)
  .setRootReducer(rootReducer)
  .setCoreParams(getCoreParams)
  .addClientAPIEvent(INJECT_VIDEO_LOGO)
  .addClientAPIEvent(GET_PAGE_DATA)
  .addClientAPIEvent(INJECT_ARTICLE_BLOCK_BY_INDEX_ARRAY)
  .addClientAPIEvent(INJECT_BUTTON_TO_FOOTER_LINKS_SECTION)
  .addClientAPIEvent(INJECT_BUTTON_TO_MENU)
  .addClientAPIEvent(GET_PALETTE_DATA)
  .addClientAPIEvent(INJECT_ADS)
  .build();
